import styled from 'styled-components';

import { Box } from 'components/Box';

export const LayoutChildrenBox = styled(Box)`
  @media print {
    border: none;
    flex: none;
    padding-bottom: 0;
    background: transparent;
  }
`;
